module.exports = __webpack_public_path__ + "static/img/logo2.6491e791.png";